module.exports = __webpack_public_path__ + "img/4_b.e38c1b07.jpg";